<template>
  <div class="qc-playform-modal qc-login-form-modal">
    <div class="qc-modal-warp">
      <div class="qc-playform-overlay"></div>
      <div class="qc-playform-layout">
        <Header closeBtnIcon="close_btn" :closeHandle="props.onClose" />

        <div class="qc-playform-content qc-login-content">
          <div class="qc-title qc-text-center">
            {{ language[LANGUAGE_KEY.TITLE_ACCOUNT_LOGIN] }}
          </div>
          <div class="qc-playform-form">
            <div :class="'qc-light-light-' + hightLightFormItem">
              <div :class="'qc-form-item ' + (showAccountSelect ? 'selected-box' : '')">
                <div class="qc-form-item-label">
                  <div class="qc-sprites qc-sprites-email_icon"></div>
                </div>
                <div class="qc-form-input">
                  <input type="text"
                    style="width: 100%;"
                    :placeholder="language[LANGUAGE_KEY.EMAIL_INPUT_PLACEHOLDER]"
                    name="email"
                    v-model.trim="email"
                    autocomplete="off"
                    @input="handleAccountInput"
                    @focus="() => onFocus(1)"
                    @blur="onBlur" />
                </div>
                <div v-if="accountList.length" class="qc-form-operation" @click="toggleAccountSelect()">
                  <div class="qc-sprites qc-sprites-more_icon"></div>
                </div>
                <div class="qc-select-box qc-channel-select-box">
                  <div class="qc-select-mask" @click="toggleAccountSelect()"></div>
                  <div class="qc-select-line"></div>
                  <ul>
                    <li v-for="(item, idx) in accountList" :key="idx" class="qc-select-options-item" @click="selectAccount(item)">
                      <span>{{ item.account }}</span>
                      <b class="qc-options-delete" @click.stop="removeAccountItem(item.account)"></b>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="qc-form-item">
                <div class="qc-form-item-label">
                  <div class="qc-sprites qc-sprites-password_icon"></div>
                </div>
                <div class="qc-form-input">
                  <input :type="showPassword ? 'text' : 'password'"
                    :placeholder="language[LANGUAGE_KEY.PASSWORD_INPUT_PLACEHOLDER]"
                    name="password"
                    v-model.trim="password"
                    autocomplete="off"
                    @input="handlePasswordInput"
                    @focus="() => onFocus(2)"
                    @blur="onBlur" />
                </div>
                <div v-if="!isSelected" class="qc-form-operation" @click="togglePassword()">
                  <div v-if="showPassword" class="qc-sprites qc-sprites-password_show_icon"></div>
                  <div v-else class="qc-sprites qc-sprites-password_hide_icon"></div>
                </div>
              </div>
              <div :class="'qc-default-btn qc-confirm-btn ' + (isFormInvalid ? 'qc-disable-btn' : '')"
                @click="onLogin()">
                {{ language[LANGUAGE_KEY.DESC_LOGIN_BTN] }}
              </div>
            </div>
          </div>

          <div v-if="otherLoginWays.length > 1" class="other-login-methods">
            <div class="other-login-text qc-text-center">
              {{ language[LANGUAGE_KEY.DESC_OTHER_LOGIN_METHOD] }}
            </div>
            <ul :class="'login-methods-list-' + otherLoginWays.length">
              <li v-if="otherLoginWays.includes(LOGIN_TYPE.GOOGLE)">
                <div class="qc-sprites qc-sprites-google_icon"></div>
                <div id="google_btn" style="position:absolute; opacity: 0.01;"></div>
              </li>
              <li v-if="otherLoginWays.includes(LOGIN_TYPE.APPLE)">
                <div class="qc-sprites qc-sprites-apple_icon" @click="openApple()"></div>
              </li>
              <!-- <li>
                <div class="qc-sprites qc-sprites-x_icon"></div>
              </li> -->
              <li v-if="otherLoginWays.includes(LOGIN_TYPE.FACEBOOK)">
                <div class="qc-sprites qc-sprites-facebook_icon" @click="onFBLogin()"></div>
              </li>
              <!-- <li>
                <div class="qc-sprites qc-sprites-amx_icon"></div>
              </li> -->
              <li v-if="otherLoginWays.includes(LOGIN_TYPE.GUEST)">
                <div class="qc-sprites qc-sprites-tourist_icon" @click="onTouristLogin()"></div>
              </li>
            </ul>
          </div>
        </div>
        <div class="qc-login-footer">
          <span @click="openForgotPassword()">{{ language[LANGUAGE_KEY.DESC_RECOVER_PASSWORD] }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, computed, onMounted, watch } from 'vue';
import { Toast } from '../../subComponents/Toast/index';
import Header from '../../subComponents/Header/index.vue';
import ApiManager from '../../core/api/index';
import configManager from '../../core/config/index';
import { LOGIN_TYPE } from '../../core/constants/api';
import { LANGUAGE_KEY } from '../../core/constants/language';
import type { InternationalAccountProps, AccountItem } from '../types';

const props = withDefaults(defineProps<InternationalAccountProps>(), {});

const language = configManager.getLanguage();
const otherLoginWays = configManager.getLoginWays().main;

const email = ref('');
const emailError = computed(() => {
  if (!email.value) {
    return language[LANGUAGE_KEY.PROMPT_INPUT_CORRECT_EMAIL];
  }
  // 简单的正则表达式校验邮箱格式
  if (!/\S+@\S+\.\S+/.test(email.value)) {
    return language[LANGUAGE_KEY.PROMPT_INPUT_CORRECT_EMAIL];
  }
});
const password = ref('');
const passwordError = computed(() => {
  if (!password.value) {
    return language[LANGUAGE_KEY.PROMPT_INPUT_CORRECT_PASSWORD];
  }
  if (!new RegExp('^.{6,32}$').test(password.value)) {
    return language[LANGUAGE_KEY.PROMPT_INPUT_CORRECT_PASSWORD];
  }
});


// 高亮的表单行
const hightLightFormItem = ref(0);
// 表单聚焦
const onFocus = (rowIdx?: number) => {
  rowIdx && (hightLightFormItem.value = rowIdx);
};
const onBlur = () => {
  hightLightFormItem.value = 0;
};


const showPassword = ref(false);
const togglePassword = () => {
  showPassword.value = !showPassword.value;
};

const isSelected = ref(false);
const showAccountSelect = ref(false);
const toggleAccountSelect = () => {
  showAccountSelect.value = !showAccountSelect.value;
};
const handleAccountInput = () => {
  if (isSelected.value) {
    password.value = '';
    isSelected.value = false;
  }
};
const handlePasswordInput = () => {
  if (isSelected.value) {
    isSelected.value = false;
    password.value = '';
  }
};

const isFormInvalid = computed(() => {
  return !!passwordError.value || !!emailError.value;
});

const accountListStr = localStorage.getItem('QC_PLATFORM_UI_EMAIL_ACCOUNT_LIST');
const accountList = ref((accountListStr && props.autoDown) ? JSON.parse(accountListStr) : []);
// 过滤过期的账号
function filterInvalidAccount () {
  accountList.value = accountList.value.filter((acc: AccountItem) => acc.accessToken && acc.expireIn && acc.expireIn > Math.floor(Date.now() / 1000));
}
filterInvalidAccount();

const addAccountItem = (accountItem: AccountItem) => {
  if (!props.autoDown) { return; }
  const index = accountList.value.findIndex((acc: AccountItem) => acc.account === accountItem.account);
  if (index === -1) {
    accountList.value.unshift(accountItem);
    accountList.value.length > 5 && (accountList.value.length = 5);
  } else {
    accountList.value.splice(index, 1);
    accountList.value.unshift(accountItem);
  }
  localStorage.setItem('QC_PLATFORM_UI_EMAIL_ACCOUNT_LIST', JSON.stringify(accountList.value));
};

const removeAccountItem = (_account: string) => {
  const index = accountList.value.findIndex((item:AccountItem) => item.account === _account);
  if (index !== -1) {
    accountList.value.splice(index, 1);
  }
  if (accountList.value.length === 0) {
    showAccountSelect.value = false;
  }
  localStorage.setItem('QC_PLATFORM_UI_EMAIL_ACCOUNT_LIST', JSON.stringify(accountList.value));
};

const selectAccount = (accountItem: AccountItem) => {
  email.value = accountItem.account;
  showPassword.value = false;
  password.value = '1111111111111';
  isSelected.value = true;
  showAccountSelect.value = false;
};

const onLogin = async () => {
  if (emailError.value) {
    Toast(emailError.value);
    return;
  } else if (passwordError.value) {
    Toast(passwordError.value);
    return;
  }

  if (isSelected.value) {
    const idx = accountList.value.findIndex((item: AccountItem) => item.account === email.value);
    const accountItem = accountList.value[idx];
    const isValid = await ApiManager.getInstance().user.checkToken(accountItem.accessToken);
    if (isValid) {
      loginCallback(
        { code: 200, metadata: { access_token: accountItem.accessToken } },
        { loginWay: 'account', data: { account: accountItem.account } }
      );
    } else {
      Toast(language[LANGUAGE_KEY.TOKEN_EXPIRED_PROMPT]);
      removeAccountItem(accountItem.account);
      password.value = '';
      isSelected.value = false;
      showPassword.value = false;
      showAccountSelect.value = false;
    }
    return ;
  }

  const loginResponse = await ApiManager.getInstance().user.login({
    type: LOGIN_TYPE.ACCOUNT,
    account: email.value,
    password: password.value
  });

  if (loginResponse.code === 200) {
    const { access_token, expires_in } = loginResponse.metadata;
    addAccountItem({ account: email.value, accessToken: access_token, expireIn: expires_in });
  }

  loginCallback(loginResponse, { loginWay: 'account', data: { account: email.value } });
};

/**
 * 动态加载JavaScript文件
 * @param {string} src - 脚本文件URL
 * @param {string} id - 脚本标签ID
 * @returns {Promise} 返回Promise对象
 */
const loadScript = (src: string, id: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    // 检查是否已经加载过
    if (document.getElementById(id)) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.head.appendChild(script);
    console.log(`${id}登录插件加载成功`);
  });
};

const loginCallback = (response: any, otherInfo: any) => {
  if (response.code === 200) {
    const { access_token } = response.metadata;
    props.onFinish(access_token, otherInfo);
    email.value = '';
    password.value = '';
    isSelected.value = false;
    showPassword.value = false;
    showAccountSelect.value = false;
  } else {
    Toast(response.message);
  }
};

/**
 * 初始化Google登录
 */
const initGoogleLogin = async () => {
  try {
    await loadScript('https://accounts.google.com/gsi/client', 'google');
    if (!(props.clientId && props.clientId.google)) {
      throw new Error('google ID 不存在，无法初始化谷歌SDK插件');
    }
    // 这里可以添加Google登录的初始化逻辑
    google.accounts.id.initialize({
      client_id: props.clientId.google,
      callback: async (response: any) => {
        const token = response.credential;
        const loginResponse = await ApiManager.getInstance().user.login({
          type: LOGIN_TYPE.GOOGLE,
          oauth_token: token
        });
        loginCallback(loginResponse, { loginWay: 'google', data: {} });
      }
    });
    const googleBtn = document.getElementById('google_btn');
    if (googleBtn) {
      googleBtn.innerHTML = '';
      google.accounts.id.renderButton(
        googleBtn,
        { type: 'standard', theme: 'outline', shape: 'square', width: '400' }  // 自定义按钮样式
      );
    } else {
      throw new Error('找不到id="google_btn"节点');
    }
  } catch (error) {
    console.error('Google登录插件加载失败:', error);
  }
};

/**
 * 初始化Facebook登录
 */
const initFacebookLogin = async () => {
  try {
    await loadScript('https://connect.facebook.net/en_US/sdk.js', 'facebook');
    if (!(props.clientId && props.clientId.facebook)) {
      throw new Error('facebook ID 不存在，无法初始化谷歌SDK插件');
    }
    // 添加Facebook登录的初始化逻辑
    FB.init({
      appId      : props.clientId.facebook,
      cookie     : true,
      xfbml      : true,
      version    : 'v21.0'
    });
  } catch (error) {
    console.error('Facebook登录插件加载失败:', error);
  }
};

/**
 * 初始化Apple登录
 */
const initAppleLogin = async () => {
  try {
    await loadScript('https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js', 'apple');
    
    if (!(props.clientId && props.clientId.apple)) {
      throw new Error('apple ID 不存在，无法初始化谷歌SDK插件');
    }
    // 添加Apple登录的初始化逻辑
    AppleID.auth.init({
      clientId : props.clientId.apple,
      scope : 'name email',
      redirectURI: `${window.location.origin}/`,
      response_type: "code id_token",
      state: "",
      usePopup: !0
    });
  } catch (error) {
    console.error('Apple登录插件加载失败:', error);
  }
};

/**
 * 初始化所有第三方登录插件
 */
const initThirdPartyLogins = async () => {
  const promises: Promise<void>[] = [];

  // 根据配置的ID跟config配置决定加载哪些插件
  const { google: googleID, facebook: facebookID, apple: appleID } = props.clientId || {};
  const hasGoogleLogin = otherLoginWays.includes(LOGIN_TYPE.GOOGLE);
  const hasFacebookLogin = otherLoginWays.includes(LOGIN_TYPE.FACEBOOK);
  const hasAppleLogin = otherLoginWays.includes(LOGIN_TYPE.APPLE);
  if (googleID && hasGoogleLogin) {
    promises.push(initGoogleLogin());
  }

  if (facebookID && hasFacebookLogin) {
    promises.push(initFacebookLogin());
  }

  if (appleID && hasAppleLogin) {
    promises.push(initAppleLogin());
  }
  try {
    await Promise.all(promises);
    console.log(`所有第三方登录插件(${promises.length}个)加载完成 \n googleID: ${
      !!googleID}; onlineConfig: ${hasGoogleLogin}; result: ${!!googleID && hasGoogleLogin} \n facebookID: ${
      !!facebookID}; onlineConfig: ${hasFacebookLogin}; result: ${!!facebookID && hasFacebookLogin} \n appleID: ${
      !!appleID}; onlineConfig: ${hasAppleLogin}; result: ${!!appleID && hasAppleLogin}`);
  } catch (error) {
    console.error('部分第三方登录插件加载失败:', error);
  }
};

// 苹果授权
const openApple = async () => {
  const { authorization } = await AppleID.auth.signIn();
  const loginResponse = await ApiManager.getInstance().user.login({
    type: LOGIN_TYPE.APPLE,
    oauth_token: authorization.id_token
  });
  loginCallback(loginResponse, { loginWay: 'apple', data: {} });
};

// facebook授权
const onFBLogin = async () => {
  const fbData: any = await (new Promise((resolve, reject) => {
    FB.login(function(response) {
      if (response.status === 'connected') {
        resolve(response);
      } else {  // 登录失败
        reject(response);
      }
    }, { scope: 'public_profile,email' });
  }));

  const { accessToken, userID } = fbData.authResponse;
  const loginResponse = await ApiManager.getInstance().user.login({
    type: LOGIN_TYPE.FACEBOOK,
    oauth_token: accessToken,
    // oauth_id: userID
  });
  loginCallback(loginResponse, { loginWay: 'facebook', data: {  } });
};

// 游客登录
const onTouristLogin = async () => {
  // 判断当前localstore里面是否存在游客数据
  let t_account = localStorage.getItem('QCPlatform_tourist_account');
  let t_password = localStorage.getItem('QCPlatform_tourist_password');

  if (!t_account || !t_password) {
    // 创建游客
    const guestResponse = await ApiManager.getInstance().user.createGuest();
    if (guestResponse.code !== 200) {
      Toast(guestResponse.message);
      return;
    }
    const { account, password } = guestResponse.data;
    const loginResponse = await ApiManager.getInstance().user.login({
      type: LOGIN_TYPE.GUEST,
      account,
      password
    });
    loginCallback(loginResponse, { loginWay: 'guest', data: { account } });
    localStorage.setItem('QCPlatform_tourist_account', account);
    localStorage.setItem('QCPlatform_tourist_password', password);
  }
};

// 页面加载完成
onMounted(() => {
  // 初始化第三方登录插件
  initThirdPartyLogins();
});

watch(() => props.clientId, () => {
  initThirdPartyLogins();
});


</script>